import { useContext } from 'react';
import { RTLContext } from './RTLContext';
import type { RTLContextType } from './RTLContext';

export const useRTL = (): RTLContextType => {
  const context = useContext(RTLContext);
  if (context === undefined) {
    throw new Error('useRTL must be used within an RTLProvider');
  }
  return context;
};
